import { render, staticRenderFns } from "./SpecialItems.vue?vue&type=template&id=f19bd774&"
import script from "./SpecialItems.vue?vue&type=script&lang=js&"
export * from "./SpecialItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports